import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  min-width: 600px;
  max-width: 800px;

  span {
    color: ${({ theme }) => theme.text};
    font-size: 14px;
  }
`;

export const EditorContainer = styled.div`
  height: 300px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
`;
